import { Head, useForm } from "@inertiajs/react"
import { Container, Section } from "@radix-ui/themes"
import TrackForm, { TrackFormData, TrackTimeZoneOption } from "@/shared/admin/TrackForm"

interface Props {
  track: {
    id: number
    slug: string
    [key: string]: any
  }
  has_venue_map?: boolean
  time_zones: TrackTimeZoneOption[]
  errors?: { [key: string]: string[] }
}

export default function EditTrack({ track, has_venue_map, time_zones, errors }: Props) {
  const initialData: TrackFormData = {
    track: {
      name: track.name || "",
      street: track.street || "",
      city: track.city || "",
      state: track.state || "",
      country: track.country || "",
      zip: track.zip || "",
      time_zone: track.time_zone || "",
      latitude: track.latitude?.toString() || "",
      longitude: track.longitude?.toString() || "",
      instagram: track.instagram || "",
      website_url: track.website_url || "",
      google_map_url: track.google_map_url || "",
      instagram_hashtag: track.instagram_hashtag || "",
      rules: track.rules || "",
      prices: track.prices || "",
      parking: track.parking || "",
      connectivity: track.connectivity || "",
      transportation: track.transportation || "",
      accessibility: track.accessibility || "",
      family_info: track.family_info || "",
      prohibited_items: track.prohibited_items || "",
      pit_access: track.pit_access || "",
      media_auto_approval: track.media_auto_approval || false,
      media_auto_approval_limit: track.media_auto_approval_limit ?? 0,
      venue_map: null,
    },
  }

  const { data, setData, patch, processing } = useForm(initialData)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    patch(`/tracks/${track.slug}`)
  }

  return (
    <div className="flex">
      <Head title={`Edit ${track.name}`} />
      <div className="grow">
        <Section>
          <Container size="4">
            <TrackForm
              data={data}
              setData={setData}
              onSubmit={handleSubmit}
              processing={processing}
              errors={errors}
              title={`Edit ${track.name}`}
              submitLabel="Update Track"
              hasVenueMap={has_venue_map}
              timeZones={time_zones}
            />
          </Container>
        </Section>
      </div>
    </div>
  )
}
